import type { FC } from "react";

import { Accordion, AccordionItem, Heading } from "src/components";
import { CloseIcon, InfoIcon } from "src/icons";
import { useTranslation } from "src/translations";

const FAQ_ITEMS = ["foreignAccount", "eur", "card"] as const;

export const PaymentInstructions: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="grid gap-4">
            <div className="flex items-center rounded-lg border p-4 text-sm text-brand" role="alert">
                <InfoIcon className="me-3 inline size-4 shrink-0" />
                <p>{t("orders.pay.transferDetails.notice")}</p>
            </div>
            <div>
                <Heading level={6} className="mb-1 normal-case">
                    {t("orders.pay.transferDetails.info.title")}
                </Heading>
                <p className="text-sm">{t("orders.pay.transferDetails.info.text")}</p>
            </div>
            <div>
                <Heading level={6} className="mb-1 normal-case">
                    {t("orders.pay.transferDetails.faq.title")}
                </Heading>
                <Accordion>
                    {FAQ_ITEMS.map((item) => (
                        <AccordionItem
                            key={item}
                            value={item}
                            className="my-2 overflow-hidden rounded border border-primary p-4"
                            title={
                                <span className="text-left text-sm font-medium">
                                    {t(`orders.pay.transferDetails.faq.items.${item}.question`)}
                                </span>
                            }
                            content={<p className="text-sm">{t(`orders.pay.transferDetails.faq.items.${item}.answer`)}</p>}
                            triggerClassName="[&>div]:data-[state=closed]:rotate-45"
                            triggerIcon={
                                <div className="shrink-0 transition-transform duration-300 data-[state=closed]:rotate-45">
                                    <CloseIcon className="size-5" />
                                </div>
                            }
                        />
                    ))}
                </Accordion>
            </div>
        </div>
    );
};
